export default {
  onSelectedPatient (patient) {

  },
  setPlansFromCovenant (covenant) {
    if (covenant) {
      if (covenant.active_plans) {
        this.plans = covenant.active_plans
      } else {
        this.plans = []
      }
    } else {
      this.plans = []
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/settings/covenants/form/resources/methods.js